import React from 'react';
// import ReactTooltip from 'react-tooltip';
import {LIST, STRING_LIST} from "../constant";
import PropTypes from 'prop-types';


const Avatar = React.memo((props) => {
    const anArray = props?.name?.split(' ') ? props.name?.split(' ').filter(item => item) : [];
    const alphabet = [];
    let color = '#000000';
    for (let i = 0; i < 26; i++) {
        alphabet.push((i + 10).toString(36));
        if (anArray[0]?.charAt(0).toLowerCase() === alphabet[i]) {
            color = STRING_LIST.COLOR[i];
        }
    }

    const imageError = (e) => {
        e.target.src = 'https://files.superworks.com/custom/images/user-avatar.png'
    }

    return (
        <React.Fragment>
            <div className={`u_avatar ${props.className || ''}`}>
                {(props.image !== '' && props.image !== undefined) ?
                    <img draggable='false' src={props.thumbor + props.s3Url + props.image} onError={(e) => imageError(e)}
                     alt={anArray[0]} className={`u_avatar-image ${props.className}`}
                         style={{width: `${props.width}px`, height: `${props.width}px`}}/>
                    :
                    <div className={`u_avatar-content ${props.className || ''}`}
                         style={{backgroundColor: `${color}`, width: `${props.width}px`, height: `${props.width}px`}}>
                        {anArray.length === 1 ?
                            <span className="u_m-auto" style={{
                                fontSize: `${(props.width / 3) / 10}rem`,
                                lineHeight: `${(props.width / 3) / 10}rem`
                            }}>{`${anArray[0]?.charAt(0)}${anArray[0]?.charAt(1)}`}</span>
                            :
                            <span className="u_m-auto" style={{
                                fontSize: `${(props.width / 3) / 10}rem`,
                                lineHeight: `${(props.width / 3) / 10}rem`
                            }}>{`${anArray[0]?.charAt(0)}${anArray[1]?.charAt(0)}`}</span>}
                    </div>

                }
            </div>
        </React.Fragment>
    );
});

Avatar.propTypes = {
    image: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    thumbor: PropTypes.string,
    s3Url: PropTypes.string,

};
Avatar.defaultProps = {
    width: 40,
    thumbor: ''
};

export default Avatar;
